export default __webpack_public_path__ + "411712c66678d3038baadde8e938aac9.png";